import React, { forwardRef, InputHTMLAttributes, Ref } from "react";

import classnames from "classnames";

import {
  StyledRadioButton,
  StyledRadioInput,
  StyledRadioLabel,
} from "./Styles";
import RadioButtonIcon from "../Icons/collection/RadioButton";

export interface IRadioButtonProps {
  /** Class names */
  className?: string;
  /** Set hover style */
  hover?: boolean;
  /** Id for RadioButton */
  id?: string;
}

export const RadioButton = forwardRef(
  (
    {
      className = "",
      id = "radio",
      hover,
      ...props
    }: InputHTMLAttributes<HTMLInputElement> & IRadioButtonProps,
    ref: Ref<HTMLInputElement> | null | undefined
  ) => {
    return (
      <StyledRadioButton
        className={classnames(
          "c-radio-btn",
          {
            "c-radio-btn__hover": hover,
            "c-radio-btn__controlled": typeof hover === "boolean",
          },
          className
        )}
        $isHovered={hover}
        $isControlled={typeof hover === "boolean"}
      >
        <StyledRadioInput
          id={id}
          className="c-radio-btn--input"
          type="radio"
          ref={ref}
          {...props}
        />
        <StyledRadioLabel htmlFor={id} className="c-radio-btn--label">
          <RadioButtonIcon width="16" height="16" />
        </StyledRadioLabel>
      </StyledRadioButton>
    );
  }
);

RadioButton.displayName = "RadioButton";
